module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6tY3v"))).then(() => parcelRequire('7ifNd'));